<template>
	<div class="activityManage ">
		<div class="itemTitleBox disBetween">
			<div class="disStart">
				<span class="title">充电金额标准配置</span>
			</div>
			<div class="icon_add iconBox" @click="openDia" title="新增充电金额配置"></div>
		</div>
		<Container @drop="onDrop" class="listBox " v-if="disposeList && disposeList.length>0" v-loading="loading">
			<Draggable class="itemBox disBetween" v-for="(item,inx) in disposeList" :key="inx">
				<div class="itemLeft boxShaw disBetween" :class="{active:item.amountStatus==1}">
					<div class="nameBox">
						<div class="titleBox">充值金额</div>
						<div class="numBox disStart">
							<div class="inputBox">
								<el-input @focus="focusact($event,item.moneyAmount)" v-model="item.moneyAmount" type="Number" placeholder=""
									@change="changeinput($event,1,item)"></el-input>
							</div>
							<div class="unitBox">元</div>
						</div>
					</div>
					<div class="lineBox"></div>
					<div class="nameBox nameBox2">
						<div class="titleBox">到账金额</div>
						<div class="numBox disBetween">
							<div class="numItem disStart">
								充值金：
								<div class="inputBox">
									<el-input @focus="focusact($event,item.coinAmount)" v-model="item.coinAmount" type="Number" placeholder=""
										@change="changeinput($event,2,item)"></el-input>
								</div>
								<div class="unitBox">元</div>
							</div>
							<div class="numItem disStart">
								赠送金：
								<div class="inputBox">
									<el-input @focus="focusact($event,item.extraCoinAmount)" v-model="item.extraCoinAmount" type="Number" placeholder=""
										@change="changeinput($event,3,item)"></el-input>
								</div>
								<div class="unitBox">元</div>
							</div>
						</div>
					</div>
				</div>
				<div class="itemRight ">
					<div class="iconItem disCenter">
						<span class="lockIcon" v-if="item.amountStatus==2" @click="btnact(1,item)"></span>
						<span class="unlockIcon" v-if="item.amountStatus==1" @click="btnact(2,item)"></span>
					</div>
					<div class="iconItem disCenter">
						<span class="deletIcon" @click="delet(item,inx)"></span>
					</div>
				</div>
			</Draggable>
		</Container>
		<!-- <Container @drop="onDrop">
		                <Draggable v-for="item in items" :key="item.id">
		                    <div class="draggable-item">
		                        {{item.data}}
		                    </div>
		                </Draggable>
		            </Container> -->
		<div v-else class="nodataBox">
			<nodata :str="str">
				<template v-slot>
					<div class="slotBox disCenter">
						<div class="disStart" @click="openDia" title="新增充电金额配置">
							<span class="icon_add2"></span>
							<span>新增充电金额配置</span>
						</div>
					</div>
				</template>
			</nodata>
		</div>
	</div>
</template>
<script type="text/javascript">
	import nodata from "../../../../nodata/nodata.vue"
	import {
		Container,
		Draggable
	} from "vue-smooth-dnd";

	export default {
		name: "activityManage",
		components: {
			nodata,
			Container,
			Draggable
		},
		props: {

		},
		data() {
			return {
				str: "配置",
				loading: false,
				disposeList: [],
				focusNum: ""
			}
		},
		watch: {},
		mounted() {
			this.getData()
		},
		methods: {
			focusact(e, n) {
				this.focusNum = n
			},
			getData() {
				this.$api.listAllAmountBasicSet().then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "disposeList", res.obj)
						this.$emit("moduleZero", this.disposeList)
					}
				})
			},
			btnact(n, item) {
				let obj = {
					moneyAmount: item.moneyAmount,
					coinAmount: item.coinAmount,
					extraCoinAmount: item.extraCoinAmount,
					amountStatus: n,
					amountBasicSetId: item.amountBasicSetId,
				}
				this.$api.updateAmountBasicSet(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$set(item, "amountStatus", n)
						this.$emit("moduleZero", this.disposeList)
					}
				})
			},
			onDrop(dropResult) {
				let temp = this.disposeList[dropResult.removedIndex]
				this.disposeList[dropResult.removedIndex] = this.disposeList[dropResult.addedIndex]
				this.$set(this.disposeList, [dropResult.removedIndex], this.disposeList[dropResult.addedIndex])
				this.$set(this.disposeList, [dropResult.addedIndex], temp)
				// this.disposeList[dropResult.addedIndex]=temp
				
				// this.items = applyDrag(this.items, dropResult);
				
				this.$emit("moduleZero", this.disposeList)
			},
			openDia() {
				let obj = {
					moneyAmount: "1", //充值金额
					coinAmount: "1", //充值金
					extraCoinAmount: "1", //赠送金
					amountStatus: "1", //禁用状态 1未禁用 2禁用
					amountBasicSetId: "" //充值金额编号
				}
				this.$api.addAmountBasicSet(obj).then((res) => {
					if (res.returnCode == 200) {
						this.getData()
					}
				})

			},
			changeinput(e, n, item) {
				let obj = {
					moneyAmount: item.moneyAmount,
					coinAmount: item.coinAmount,
					extraCoinAmount: item.extraCoinAmount,
					amountStatus: item.amountStatus,
					amountBasicSetId: item.amountBasicSetId,
				}
				if (!(e)) {
					if (n == 1) {
						this.$message({
							type: 'warning',
							message: '充值金额不能为空!'
						});
						this.$set(item, "moneyAmount", this.focusNum)
					} else if (n == 2) {
						this.$message({
							type: 'warning',
							message: '充值金不能为空!'
						});
						this.$set(item, "coinAmount", this.focusNum)
					} else if (n == 3) {
						this.$message({
							type: 'warning',
							message: '赠送金不能为空!'
						});
						this.$set(item, "extraCoinAmount", this.focusNum)
					}
					return false
				}
				this.$api.updateAmountBasicSet(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$emit("moduleZero", this.disposeList)
					}
				}).catch((e) => {
					if (n == 1) {
						this.$set(item, "moneyAmount", this.focusNum)
					} else if (n == 2) {
						this.$set(item, "coinAmount", this.focusNum)
					} else if (n == 3) {
						this.$set(item, "extraCoinAmount", this.focusNum)
					}
				})
			},
			delet(item, inx) {
				if (this.disposeList.length == 1) {
					this.$message({
						type: 'warning',
						message: '最少保存一个标准配置!'
					});
					return false
				}
				let that = this
				this.$confirm('是否确认删除该配置项?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deleteAmountBasicSet({
						amountBasicSetId: item.amountBasicSetId
					}).then((res) => {
						if (res.returnCode == 200) {
							that.disposeList.splice(inx, 1)
							that.$emit("moduleZero", that.disposeList)
							that.$message({
								type: 'success',
								message: '删除成功!'
							});
						}
					})

				}).catch(() => {

				});

			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./activityManage.scss"
</style>
